import React from 'react';
import { SnowflakeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="relative z-10 border-t border-white/10 bg-navy-dark/50 backdrop-blur-lg pt-16 pb-8 px-6" data-id="element-28">
      <div className="container mx-auto max-w-7xl" data-id="element-29">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-30">
          <div className="col-span-1 md:col-span-2" data-id="element-31">
            <div className="flex items-center gap-2 text-frost font-bold text-2xl tracking-tight mb-4" data-id="element-32">
              <SnowflakeIcon className="w-8 h-8 text-ice" data-id="element-33" />
              <span data-id="element-34">Citadelgames</span>
            </div>
            <p className="text-white/60 max-w-sm mb-6" data-id="element-35">
              The premier cold-weather and seasonal campaign management
              platform. Orchestrating marketing with the elements.
            </p>
            <div className="text-white/50 text-sm" data-id="element-36">
              <p data-id="element-37">Limassol, Cyprus</p>
            </div>
          </div>

          <div data-id="element-38">
            <h4 className="text-white font-semibold mb-4" data-id="element-39">Platform</h4>
            <ul className="space-y-3" data-id="element-40">
              <li data-id="element-41">
                <a href="#" className="text-white/60 hover:text-ice transition-colors text-sm" data-id="element-42">
                  Frost Trigger Engine
                </a>
              </li>
              <li data-id="element-43">
                <a href="#" className="text-white/60 hover:text-ice transition-colors text-sm" data-id="element-44">
                  Meridian Scheduler
                </a>
              </li>
              <li data-id="element-45">
                <a href="#" className="text-white/60 hover:text-ice transition-colors text-sm" data-id="element-46">
                  Glacial Analytics
                </a>
              </li>
              <li data-id="element-47">
                <a href="#" className="text-white/60 hover:text-ice transition-colors text-sm" data-id="element-48">
                  Pricing
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-49">
            <h4 className="text-white font-semibold mb-4" data-id="element-50">Company</h4>
            <ul className="space-y-3" data-id="element-51">
              <li data-id="element-52">
                <a href="#" className="text-white/60 hover:text-ice transition-colors text-sm" data-id="element-53">
                  About Us
                </a>
              </li>
              <li data-id="element-54">
                <a href="#" className="text-white/60 hover:text-ice transition-colors text-sm" data-id="element-55">
                  Careers
                </a>
              </li>
              <li data-id="element-56">
                <a href="#" className="text-white/60 hover:text-ice transition-colors text-sm" data-id="element-57">
                  Blog
                </a>
              </li>
              <li data-id="element-58">
                <a href="#" className="text-white/60 hover:text-ice transition-colors text-sm" data-id="element-59">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-60">
          <p className="text-white/40 text-sm" data-id="element-61">
            © 2026 Citadelgames. All rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-62">
            <a href="#" className="text-white/40 hover:text-white text-sm transition-colors" data-id="element-63">
              Privacy Policy
            </a>
            <a href="#" className="text-white/40 hover:text-white text-sm transition-colors" data-id="element-64">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}